<template>
  <ul class="zk-select-group__wrap">
    <li class="zk-select-group__title">{{ label }}</li>
    <li>
      <ul class="zk-select-group">
        <slot></slot>
      </ul>
    </li>
  </ul>
</template>

<script type="text/babel">
  import Emitter from 'theme/mixins/emitter';

  export default {
    mixins: [Emitter],

    name: 'zk-option-group',

    props: {
      label: String,
      disabled: {
        type: Boolean,
        default: false
      }
    },

    watch: {
      disabled(val) {
        this.broadcast('option', 'handleGroupDisabled', val);
      }
    },

    mounted() {
      if (this.disabled) {
        this.broadcast('option', 'handleGroupDisabled', this.disabled);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// option-group.vue?6c755faf